import { Button } from '@mui/material'
import styled, { css } from 'styled-components'

const sizeStyles = {
  lg: css`
    padding: 8px 22px;
  `,
  md: css`
    padding: 6px 16px;
  `,
  sm: css`
    padding: 4px 10px;
  `
}

export const StyleButtonContained = styled(Button)<{
  size: 'lg' | 'md' | 'sm'
}>`
  && {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background: linear-gradient(
      129deg,
      ${(props) => props.theme.colors.red} 0%,
      ${(props) => props.theme.colors.salmon} 45%,
      ${(props) => props.theme.colors.red} 100%
    );
    background-size: 200% 200%;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    transition:
      background-position 0.3s ease,
      box-shadow 0.3s ease;

    ${({ size }) => sizeStyles[size]}

    &:hover {
      background-position: right center;
    }
  }
`
